// extracted by mini-css-extract-plugin
module.exports = {"wrap":"PlaceSpend_wrap__23RPM"};